import { useEffect, useLayoutEffect, useRef } from 'react'
import { registerBackHandler } from '@/lib/navigation/back-handlers'

// Keep stack order tied to opening, even when a parent supplies a new callback.
export function useBackHandler(active: boolean, onClose: () => void) {
  const closeRef = useRef(onClose)
  useLayoutEffect(() => { closeRef.current = onClose }, [onClose])
  useEffect(() => {
    if (!active) return
    return registerBackHandler(() => {
      closeRef.current()
      return true
    })
  }, [active])
}
